import { render, staticRenderFns } from "./FileCreate.vue?vue&type=template&id=c15a9428&scoped=true&"
import script from "./FileCreate.vue?vue&type=script&lang=js&"
export * from "./FileCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15a9428",
  null
  
)

export default component.exports